<template>
	<v-row class="mt-0 pt-0">
        <v-col md="6" cols="12" sm="12" class="px-1 my-0 py-0" style="padding-top:0 !important;padding-bottom:0 !important;display:flex;width:200px">
          <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="$store.state.searchdate"
                  label="Date"
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                  clearable
                  @click:clear="clearDate"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="$store.state.searchdate"
                no-title
                scrollable
                @input="menu = false"
                @click:date="selectedDate"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="#f9780d"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="#f9780d"
                  @click="cleardate"
                >
                  Clear
                </v-btn>
                <v-btn
                  text
                  color="#f9780d"
                  @click="$refs.menu.save($store.state.searchdate)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
        </v-col>
        <v-col md="6" cols="12" sm="12" class="px-1" style="padding-top:0 !important;padding-bottom:0 !important;display:flex;width:200px">
          <v-text-field
            v-model="search"
            label="Search bookings"
            solo
            hide-details="auto"
            clearable
            @click:clear="onClearClicked"
            @input="searchBooking"
          ></v-text-field>
        </v-col>
      </v-row>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'

export default {
	name: 'bookingSearch',
	components: {
	},
	data: () => ({
		messageclientdialog: false,
		fieldRules: [
          (v) => !!v || 'Field is required'
          ],
        valid: true,
        isBusy: false,
        loading: false,
        disabled: false,
        search: "",
        menu:false,

	}),
	methods: {
		selectedDate(dateselected) {
			this.$store.state.searchdate = dateselected
			this.$store.state.tableloader = true
			this.$store.dispatch('loadbookingsbydate',dateselected)
		},
		onClearClicked () {
        this.search = ''
      },
       cleardate () {
        this.$store.commit('clearDate')
        this.$store.state.tableloader = true
		    this.$store.dispatch('getBookings')
        this.menu = false
      },
      clearDate() {
      	this.$store.commit('clearDate')
      	this.$store.state.tableloader = true
		this.$store.dispatch('getBookings')
      },
      searchBooking() {
      	this.$store.commit('searchBooking',this.search)
      }
	},
	props: {},
	  computed: {
	    show: {
	      get () {
	        return this.value
	      },
	      set (value) {
	         this.$emit('input', value)
	      }
	    },
	    date: {
	      get () {
	        return this.value
	      },
	      set (value) {
	         this.$store.state.searchdate = value
	      }
	    },
	  },
	mounted() {

	},
	created() {
     
    }
}
</script>